<template>
  <div>
    <v-row class="ml-1 mt-2">
      <strong class="mt-2 mr-2">活用名</strong>
      <v-text-field
        v-model="keyword"
        hide-details
        dense
        @keyup.enter="search"
        class="text-field-search mr-10"
        outlined
      />
      <v-btn color="primary" class="font-weight-black" @click="search">{{
        $t("SEARCH")
      }}</v-btn>

      <v-spacer />
      <v-select
        class="select-record"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <!-- add item for drill-->
      <DrillAdd @resetList="handleGetListGrammar" />
    </v-row>
    <v-layout child-flex class="ml-1">
      <v-data-iterator
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        :items="listDrill"
        :key="keyListDrill"
        :loading="loadingData"
        hide-default-footer
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="(item, index) in props.items"
              :key="index"
              cols="2"
              class="card-list"
            >
              <v-card
                color="#f5f5f5"
                @click.prevent="
                  $router.push({
                    name: 'List Exercises Of Drill',
                    params: { drillId: item.Id },
                    query: {
                      title: item.name,
                    },
                  })
                "
              >
                <v-card-text class="align-start">
                  <span class="font-weight-bold">{{ item.name }}</span>
                  <div class="row pa-0 ma-0">
                    <div class="icon-trash">
                      <DrillUpdate
                        :item="item"
                        @resetList="handleGetListGrammar"
                      />
                      <!-- delete item drill -->
                      <DrillDelete
                        :item="item"
                        @resetList="handleGetListGrammar"
                      />
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-slot:loading>
          <div class="text-center mt-5">読み込み中。。。待ってください。</div>
        </template>
        <template v-slot:no-data>
          <div class="text-center mt-5">データがありません。</div>
        </template>
      </v-data-iterator>
    </v-layout>
    <BasePagination
      v-show="listDrill.length > 0"
      :pageCount="listDrill.length"
      :initialPage="pagination.page"
      :dontSetInitialPage="true"
      ref="pagination"
      :key="`pagination-${keyPagination}`"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import mixin from "@/mixin";
import DrillAdd from "@/views/drill/DrillAdd";
import DrillDelete from "@/views/drill/DrillDelete.vue";
import DrillUpdate from "@/views/drill/DrillUpdate.vue";
import BasePagination from "@/components/Pagination/BasePagination";
import { getListPratice } from "@/api/Pratice.api";
export default {
  mixins: [mixin.App, mixin.DetailGrammar],
  components: {
    BasePagination,
    DrillAdd,
    DrillDelete,
    DrillUpdate,
  },
  data() {
    return {
      keyword: "",
      listDrill: [],
      defaultListDrill: [],
      keyListDrill: 0,
      loadingData: false,
      keyPagination: 0,
    };
  },
  watch: {
    "pagination.pageCount": function () {
      this.keyPagination++;
    },
    "pagination.maxResultCount": function () {
      this.pagination.page = 1;
      this.keyPagination++;
    },
  },
  async mounted() {
    await this.handleGetListGrammar();
  },
  methods: {
    async handleGetListGrammar() {
      let params = {
        keyword: "",
        sub_key: "",
      };
      this.loadingData = true;
      await getListPratice(params)
        .then((data) => {
          this.defaultListDrill = data.result;
          this.listDrill = data.result;
          this.pagination.pageCount = data.totalCount;
        })
        .catch((error) => {
          console.log(error);
        });
      this.checkTotalPage();
      this.loadingData = false;
    },
    checkTotalPage() {
      const { totalPages } = this.$refs.pagination.$data.pager;
      const { page } = this.pagination;
      console.log("page: ", page, "totalPages: ", totalPages);
      if (page > totalPages) {
        this.pagination.page = totalPages;
      }
    },
    async search() {
      await this.handleGetListGrammar();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listDrill = this.defaultListDrill.filter(
        (item) => item.name.toLowerCase().search(keywordSearch) > -1
      );
      this.pagination.pageCount = this.listDrill.length;
    },
    changePage(value) {
      this.pagination.page = value;
    },
    async viewDetail(value) {
      this.$router.push({
        name: "Grammar Update Of Self Study",
        params: { grammar: value.Id },
      });
    },
    async resetList() {
      await this.handleGetListGrammar();
      this.pagination.page = 1;
    },
  },
};
</script>